export const titleConfig = {
  collapsedTitle: 'Show order summary',
  expandedTitle: 'Hide order summary',
  pricePlaceholder: '--.--',
}
export const orderSummaryTestId = 'checkoutOrderSummary'
export const collapsedIcon = 'chevron_down'
export const expandedIcon = 'chevron_up'
